import type { MjlMyAppsResponse } from '../mjl-my-apps.interface';
import { ssoApi } from './client';

export const fetchFavoriteApps = (signal?: AbortSignal) =>
  ssoApi.get<MjlMyAppsResponse>('/api/v1/my-account/favorite-apps', { signal });
